import img1 from '../images/product_mini_1.jpeg';

// export const analysesPagesRows = [
//   { id: 0, name: 'Головна', linkName: 'main' },
//   { id: 1, name: 'Аналізи та ціни', linkName: 'analysesAndPrices' },
//   { id: 2, name: 'Пакети досліджень', linkName: 'examinationsPackages' },
//   { id: 3, name: 'Аналізи вдома', linkName: 'analysesAtHome' },
//   { id: 4, name: 'COVID - 19', linkName: 'covid19' },
//   { id: 5, name: 'Акції', linkName: 'actions' },
//   { id: 6, name: 'Лабораторний довідник', linkName: 'laboratoryHandbook' },
//   { id: 7, name: 'Співпраця', linkName: 'coworking' },
//   { id: 8, name: 'Франшиза', linkName: 'franchise' },
//   { id: 9, name: 'Про лабораторію', linkName: 'aboutLaboratory' },
//   { id: 10, name: 'Найчастіші запитання', linkName: 'FAQ' },
//   { id: 11, name: 'Відгуки', linkName: 'feedbacks' },
//   { id: 12, name: 'Політика якості', linkName: 'qualityPolitics' },
//   { id: 13, name: 'Вакансії', linkName: 'vacancies' },
//   { id: 14, name: 'Новини', linkName: 'news' },
//   { id: 15, name: 'Політика конфедонційності', linkName: 'privacyPolicy' },
//   { id: 16, name: 'Угода користувача', linkName: 'termsOfUse' },
//   { id: 17, name: 'Контакти', linkName: 'contacts' },
//   { id: 18, name: '404', linkName: '404' },
// ];

export const analysesPagesRows = [
  { id: 0, name: 'Головна' },
  { id: 1, name: 'Аналізи та ціни' },
  { id: 2, name: 'Пакети досліджень' },
  { id: 3, name: 'Аналізи вдома' },
  { id: 4, name: 'COVID - 19' },
  { id: 5, name: 'Акції', linkName: 'actions' },
  { id: 6, name: 'Лабораторний довідник' },
  { id: 7, name: 'Співпраця' },
  { id: 8, name: 'Франшиза' },
  { id: 9, name: 'Про лабораторію' },
  { id: 10, name: 'Найчастіші запитання' },
  { id: 11, name: 'Відгуки' },
  { id: 12, name: 'Політика якості' },
  { id: 13, name: 'Вакансії' },
  { id: 14, name: 'Новини' },
  { id: 15, name: 'Політика конфедонційності' },
  { id: 16, name: 'Угода користувача' },
  { id: 17, name: 'Контакти' },
  { id: 18, name: '404' },
];

export const FAQRows = [
  {
    id: 1,
    name: 'Тут буде довге питання, щоб зрозуміти, як все працює. Якщо так сподобається - то ми так і залишимо. Сподіваюсь, що все сподобається!',
  },
  {
    id: 2,
    name: 'Рандомне питання 2',
  },
  {
    id: 3,
    name: 'Рандомне питання 3',
  },
  {
    id: 4,
    name: 'Рандомне питання 4',
  },
  {
    id: 5,
    name: 'Рандомне питання 5',
  },
  {
    id: 6,
    name: 'Рандомне питання 6',
  },
  {
    id: 7,
    name: 'Рандомне питання 7',
  },
  {
    id: 8,
    name: 'Рандомне питання 8',
  },
  {
    id: 9,
    name: 'Рандомне питання 9',
  },
];

export const vacanciesRows = [
  {
    id: 1,
    name: 'Тут буде довге питання, щоб зрозуміти, як все працює. Якщо так сподобається - то ми так і залишимо. Сподіваюсь, що все сподобається!',
  },
  {
    id: 2,
    name: 'Рандомне питання 2',
  },
  {
    id: 3,
    name: 'Рандомне питання 3',
  },
  {
    id: 4,
    name: 'Рандомне питання 4',
  },
  {
    id: 5,
    name: 'Рандомне питання 5',
  },
  {
    id: 6,
    name: 'Рандомне питання 6',
  },
  {
    id: 7,
    name: 'Рандомне питання 7',
  },
  {
    id: 8,
    name: 'Рандомне питання 8',
  },
  {
    id: 9,
    name: 'Рандомне питання 9',
  },
];

export const actionsRows = [
  {
    id: 0,
    image: img1,
    name: 'Some text0',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 1,
    image: img1,
    name: 'Some text1',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 2,
    image: img1,
    name: 'Some text2',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 3,
    image: img1,
    name: 'Some text3',
    active: false,
    endDate: '2023-01-19',
  },
  {
    id: 4,
    image: img1,
    name: 'Some text4',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 5,
    image: img1,
    name: 'Some text5',
    active: false,
    endDate: '2023-01-19',
  },
  {
    id: 6,
    image: img1,
    name: 'Some text6',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 7,
    image: img1,
    name: 'Some text7',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 8,
    image: img1,
    name: 'Some text8',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 9,
    image: img1,
    name: 'Some text9',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 10,
    image: img1,
    name: 'Some text 10',
    active: true,
    endDate: '2023-01-19',
  },
  {
    id: 11,
    image: img1,
    name: 'Some text 11',
    active: true,
    endDate: '2023-01-19',
  },
];

export const feedbacksRows = [
  {
    id: 0,
    name: 'Константин Лиходеев',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 1,
    name: 'Ольга Мазур',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 2,
    name: 'Николай',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 3,
    name: 'Some text3',
    active: false,
    date: '2023-01-19',
  },
  {
    id: 4,
    name: 'Some text4',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 5,
    name: 'Some text5',
    active: false,
    date: '2023-01-19',
  },
  {
    id: 6,
    name: 'Some text6',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 7,
    name: 'Some text7',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 8,
    name: 'Some text8',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 9,
    name: 'Some text9',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 10,
    name: 'Some text 10',
    active: true,
    date: '2023-01-19',
  },
  {
    id: 11,
    name: 'Some text 11',
    active: true,
    date: '2023-01-19',
  },
];

export const languagesRows = [
  {
    id: 1,
    name: 'Українська',
  },
  {
    id: 2,
    name: 'English',
  },
];

export const privacyPolicyRows = [
  {
    id: 1,
    name: 'Політика конфіденційності',
  },
  {
    id: 2,
    name: 'Політика конфіденційності',
  },
  {
    id: 3,
    name: 'Політика конфіденційності',
  },
  {
    id: 4,
    name: 'Політика конфіденційності',
  },
  {
    id: 5,
    name: 'Політика конфіденційності',
  },
  {
    id: 6,
    name: 'Політика конфіденційності',
  },
  {
    id: 7,
    name: 'Політика конфіденційності',
  },
  {
    id: 8,
    name: 'Політика конфіденційності',
  },
  {
    id: 9,
    name: 'Політика конфіденційності',
  },
];

export const redirectsRows = [
  {
    id: 1,
    from: '/services/solnichney-ochki 5',
    to: '/services/solnichney-ochki',
  },
  {
    id: 2,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 3,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 4,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 5,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 6,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 7,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 8,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
  {
    id: 9,
    from: '/services/solnichney-ochki',
    to: '/services/solnichney-ochki',
  },
];
